export const styles = {
  heading: {
    float: 'left',
    fontSize: 'xx-small',
    textAlign: 'left',
    width: '100%',
    padding: '0px',
    margin: '0px',
    borderBottom: '1px black solid',
    fontWeight: 'bold',
  },
  translationHeading: {
    float: 'left',
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
    padding: '0px',
    margin: '0px',
    borderBottom: '1px black solid',
    fontWeight: 'bold',
  },
  translationHeadingL: {
    float: 'left',
    fontSize: 'xx-small',
    textAlign: 'left',
    width: '50%',
    padding: '0px',
    margin: '0px',
    position: 'absolute',
    bottom: '0',
  },
  translationHeadingR: {
    float: 'right',
    fontSize: 'xx-small',
    textAlign: 'right',
    width: '50%',
    padding: '0px',
    margin: '0px',
  },
  container: {
    position: 'absolute',
    left: '0',
    right: '0',
    height: '100%',
    minHeight: '100%',
  },
  upperAlignOn: {
    top: '0',
    height: '50%',
    minHeight: '50%',
  },
  upperAlignOff: {
    top: '0',
    height: '96%',
    minHeight: '96%',
  },
  editor: {
    width: '100%',
    height: '100%',
    minHeight: '100%',
    overflowY: 'scroll',
    padding: '0 1em',
  },
  lowerAlignOn: {
    bottom: '0',
    overflowY: 'scroll',
    textAlign: 'center',
    boxSizing: 'border-box',
    borderTop: '1px black solid',
    height: '50%',
    minHeight: '50%',
  },
  lowerAlignOff: {
    bottom: '0',
    overflowY: 'hidden',
    textAlign: 'center',
    boxSizing: 'border-box',
    borderTop: '1px black solid',
    height: '4%',
    minHeight: '4%',
  },
  workspace: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'flex-start',
  },
};

export default styles;
